<template>
    <div class="home">
        <section class="skin-1" :class="{'inited': inited1}">
            <div class="maincon">
                <p class="text-1">Accelerating, Optimising & Transforming Business for Growth</p>
                <p class="text-2">Partner with the leading boutique business growth consultancy.</p>
                <div class="learn-more" @click="nextPage">Learn More</div>
                <div class="down" @click="nextPage"></div>
            </div>
            <a class="anchor" id="anchor1"></a>
        </section>
        
        <section class="skin-2" id="skin2">
            <div class="maincon flex-between-wrap">
                <div class="skin2-item">
                    <p class="value">{{value1[0]}}%</p>
                    <p class="label">Customer Satisfaction</p>
                </div>
                <div class="skin2-item">
                    <p class="value">{{value2[0]}}</p>
                    <p class="label">Years of Experience</p>
                </div>
                <div class="skin2-item">
                    <p class="value">{{value3[0]}}</p>
                    <p class="label">Industries Covered</p>
                </div>
                <div class="skin2-item">
                    <p class="value">{{value4[0]}}</p>
                    <p class="label">Countries Covered</p>
                </div>
            </div>
            <a class="anchor" id="anchor2"></a>
        </section>

        <section class="skin-3">
            <div class="maincon">
                <h2>Get Advice from One of Asia's <strong>Premier</strong> <strong>Boutique&nbsp; Management Consulting Firms</strong></h2>
                <p>We are a leading business growth management consultancy based in Asia. We help companies develop strategies specifically to accelerate their growth and optimise their operating costs. The Fourth Industrial Revolution presents many challenges for business wanting to grow and adapt to the changing expectations of customers. Unfortunately, with how fast things change and develop, it might be hard to keep track of everything. Our business consultants can help companies across the Asia and beyond understand how to implement practical strategies that will benefit their business. Whether you are seeking a new strategy to differentiate your brand or wanting to transform your business, our boutique growth management consulting firm will discuss a plan of action tailored to your needs.</p>
                <p>Don’t hesitate in reaching out to us. With years of international experience and expertise in business growth and operational cost optimisation under our belt, we are equipped to provide services that will help companies from various industries find a programme that works best.</p>

                <h1>A <strong>Passionate Team</strong> of&nbsp; Business Consultants in Asia</h1>
                <p>Operate your business at its maximum potential when you have the best customer-centric strategies in place to help optimise, accelerate and transform your business practices.</p>
                <p>Delta's consultants specialise in helping organisations achieve business transformation and growth through implementing various innovative and practical business strategies. If you’re looking for optimal business solutions to ensure your company is keeping up with the latest industry trends, you have come to the right place. Our professional Asia based business consultants have years of international experience and expertise to help you achieve your business goals.</p>
                <p>From designing a strategy through to implementation and helping you transform your business — we are one of the best boutique Asia management consulting firms to assist you with all these services.</p>

                <h2>Grow Your Company <strong>With an Award Winning Consultancy</strong></h2>
                <p>Delta Consulting Services has won several industry awards for excellence.</p>
                <p>We have prepared several papers in the resources section should you want to learn more about the&nbsp; business consulting services we offer. The papers we have written will help you get an idea of what value we can bring to your business.</p>
                <p>For any questions, queries or to set up a meeting with one of our Asia-based management consultants call +886277292428 or send email to info@delta-intltd.com, we would love to have you on board with us</p>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: 'HomeView',
    data(){
        return {
            anchor1: null,
            anchor2: null,

            inited1: false,
            inited2: false,

            value1: [0, 100], //index 0：当前值； index1：目标值
            value2: [0, 10],
            value3: [0, 20],
            value4: [0, 15],
        }
    },
    methods: {
        /**滚动条变化或窗口大小发生变化 */
        flashWindow(top){
            let {anchor1, anchor2, inited1, inited2} = this;

            if(!inited1 || !inited2){
                let headHeight = document.getElementById('header').clientHeight;
                let windowHeight = $(window).height();

                if(!inited1){
                    if(!anchor1){
                        this.anchor1 = anchor1 = $('#anchor1');
                    }
                    let anchorTop = anchor1.offset().top;
                    this.inited1 = (top >= anchorTop - windowHeight) && (top <= anchorTop - headHeight);
                }

                if(!inited2){
                    if(!anchor2){
                        this.anchor2 = anchor2 = $('#anchor2');
                    }
                    let anchorTop = anchor2.offset().top;
                    let flag = (top >= anchorTop - windowHeight) && (top <= anchorTop - headHeight);
                    if(flag){
                        this.inited2 = true;
                        this.setSkin2Values();
                    }
                }
            }
        },

        /**动态设置第二块的数据 */
        setSkin2Values(){
            let {value1, value2, value3, value4} = this;
            let array = [value1, value2, value3, value4];

            const fun = (filed, cur, tar, step)=>{
                cur += step;
                if(cur >= tar){
                    cur = tar;
                }
                this.$set(this, filed, [cur, tar]);
                if(cur < tar){
                    setTimeout(()=>{
                        fun(filed, cur, tar, step);
                    }, 50);
                }
            }

            array.forEach((item, index) => {
                let [start, target] = item;
                let step = Math.round(target / 20); //一秒执行三十次
                fun('value'+(index+1), start, target, step);
            })
        },

        /**滚动至下一屏幕 */
        nextPage(){
            this.scrTo(document.getElementById('skin2').offsetTop - document.getElementById('header').clientHeight);
        }
    }
}
</script>

<style lang="less">
    .home{
        .anchor{position: absolute;top: 50%;}

        .skin-1{
            &{background: #1d1d1d;padding: 150px 0 20px;border-bottom: 5px solid #ff2a13;color: #636363;font-weight: 500;position: relative;text-align: center;font-family: Poppins;}
            .text-1{font-size: 50px;line-height: 60px;}
            .text-2{font-weight: 400;font-size: 17px;line-height: 30px;margin: 30px 0 40px;}
            .learn-more{
                &{font-size: 19px;line-height: 48px;width: 178px;line-height: 46px;margin: 0 auto 70px;border: 2px solid #636363;border-radius: 30px;cursor: pointer;transition: all 0.3s ease;}
                &:hover{border-color: #d0c184;background: #d15134;}
            }
            .down{
                &{margin: 0 auto;width: 60px;height: 60px;z-index: 1020;cursor: pointer;transition: all 0.3s ease;border: 3px solid;border-radius: 40px;}
                &:before{content: '';border-style: solid;border-width: 0 6px 6px 0;width: 12px;height: 12px;display: block;transform: rotate(45deg);margin: 16px auto 0;border-radius: 2px;}
                &:hover{color: #ff2a13;}
            }

            .animated() {
                animation-duration: 1s;
                animation-fill-mode: both
            }
            &.inited{
                &{color: #fff;}
                .text-1{animation-name: fadeInUp;.animated();}
                .text-2{animation-name: fadeInUp;animation-delay: .2s;.animated();color: rgba(255, 255, 255, 0.75);}
                .learn-more{animation-name: fadeInUp;animation-delay: .6s;.animated();border-color: #fff;}
            }
        }

        .skin-2{
            &{padding:90px 0 55px;position: relative;}
            .skin2-item{font-size: 33px;color: #000;text-align: center;width: calc(25% - 18px);line-height: 1;margin: 10px 0;}
        }

        .skin-3{
            &{background: #fff;padding: 1px 0;}
            h1, h2{text-align: center;color: #333;letter-spacing: -2px;font-weight: 400;margin: 65px 0 10px;}
            h2{font-size: 52px;line-height: 1.2;}
            h1{font-size: 54px;line-height: 1.1;}
            p{margin-bottom: 23px;line-height: 1.7;}
            a{cursor: pointer;color: #f15a24;}
        }


        @media (max-width: 970px){
            .skin-1 .text-1{font-size: 40px;line-height: 50px;}
        }
        @media (max-width: 570px){
            .skin-1 .text-1{font-size: 30px;line-height: 40px;}
        }
        @media (max-width: 810px){
            .skin-2 .skin2-item{width: calc(50% - 10px);}
        }
        @media (max-width: 430px){
            .skin-2 .skin2-item{width: 100%;}
        }
    }
</style>
